import React from "react";
import "containers/Account/Info/Account.css";
import "containers/Account/MyChildren/MyChildren.css";
import ArrowBackward from "site_media/images/arrow-backward.png";
import AddChild from "site_media/images/Add_Child.png";
import UploadPhoto from "site_media/images/Default-profile-picture.png";
import cookie from "react-cookies";

class Children extends React.Component {
  onUpdateUser(email) {
    cookie.save("user_email", email);
    window.location.reload(false);
  }

  render() {
    return (
      <div style={{ display: "block" }} className="account-menu">
        <div className="header__wrapper">
          <div className="header__logo">
            <div className="header-menu-mobile">
              <a href="/projects">
                <img src={ArrowBackward} alt="Backward Arrow" />
              </a>
            </div>
          </div>
          <div className="header-title">My Children</div>
        </div>
        <div>
          <div className="menu__content">
            {this.props.data
              ? this.props.data.map((item) => (
                  <div className="menu__item" key={item.email}>
                    <img
                      className="profile-picture-list"
                      src={item.profile_pic || UploadPhoto}
                      alt="Child name"
                    />
                    <div onClick={this.onUpdateUser.bind(this, item.email)}>
                      {" "}
                      {item.full_name}{" "}
                    </div>
                  </div>
                ))
              : ""}
            <div className="menu__item">
              <img src={AddChild} alt="Add child" />
              <a href={"/add-child"}> Add Child</a>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Children;
